import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function DepositPage() {
  const [cryptoList, setCryptoList] = useState([]);
  const [selectedCrypto, setSelectedCrypto] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [staffWhatsapp, setStaffWhatsapp] = useState(null);
  const [user, setUser] = useState(null);

  // 🔹 Ambil user dari localStorage sekali di awal
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        setUser(parsed);
      } catch (err) {
        console.error("Failed to parse user JSON:", err);
      }
    }
  }, []);

  // 🔹 Ambil nomor WhatsApp staff setelah user tersedia
  useEffect(() => {
    if (user && user.username) {
      fetch("https://api.backofficemain.com/get_staff_whatsapp.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: user.username }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.whatsapp) {
            setStaffWhatsapp(data.whatsapp);
          } else {
            console.warn("Didn't find WhatsApp staff:", data);
          }
        })
        .catch((err) => console.error("Failed to pick up WhatsApp staff:", err));
    }
  }, [user]); // <-- hanya dijalankan ketika user sudah tersedia

  // 🔹 Ambil list crypto bank
  useEffect(() => {
    fetch("https://api.backofficemain.com/get_crypto_bank.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) setCryptoList(data.data);
        else if (Array.isArray(data)) setCryptoList(data);
        else console.error("The data format does not match:", data);
      })
      .catch((err) => console.error("Failed to retrieve crypto data:", err));
  }, []);

  const handleDeposit = () => {
    if (!amount || parseFloat(amount) <= 0) {
      alert("Enter a valid deposit amount.");
      return;
    }
    if (!selectedCrypto) {
      alert("Choose a crypto bank first.");
      return;
    }
    if (!walletAddress) {
      alert("Enter crypto wallet address.");
      return;
    }
    if (!staffWhatsapp) {
      alert("WhatsApp staff not found for your referra.");
      return;
    }

    const message = encodeURIComponent(`Hello, I would like to deposit an amount of $${amount}.`);
    window.open(`${staffWhatsapp}?text=${message}`, "_blank");
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-lg p-4">
        <h3 className="text-center mb-4 fw-bold">Deposit Funds</h3>

        {/* Input Nominal Deposit */}
        <div className="mb-3">
          <label className="form-label">Deposit Amount ($)</label>
          <input
            type="text"
            className="form-control"
            value={amount}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*$/.test(val)) {
                setAmount(val.replace(/^0+/, "") || "");
              }
            }}
            placeholder="Enter the deposit amount"
          />
          <small className="text-muted">Minimum Deposit $10.</small>
        </div>

        {/* Dropdown Crypto Bank */}
        <div className="mb-3">
          <label className="form-label">Crypto Bank</label>
          <select
            className="form-select"
            value={selectedCrypto}
            onChange={(e) => setSelectedCrypto(e.target.value)}
          >
            <option value="">Select crypto bank</option>
            {cryptoList.length > 0 ? (
              cryptoList.map((crypto) => (
                <option key={crypto.id} value={crypto.id}>
                  {crypto.crypto_name}
                </option>
              ))
            ) : (
              <option value="">(No crypto data)</option>
            )}
          </select>
        </div>

        {/* Input Wallet */}
        <div className="mb-3">
          <label className="form-label">Wallet Address</label>
          <input
            type="text"
            className="form-control"
            value={walletAddress}
            onChange={(e) => setWalletAddress(e.target.value)}
            placeholder="Enter your crypto wallet address"
          />
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-success px-4 py-2" onClick={handleDeposit}>
            💰 Deposit
          </button>
        </div>
      </div>
    </div>
  );
}
